import { Pipe, PipeTransform } from '@angular/core';
import { DatexPipe } from './datex';

@Pipe({
  name: 'dateRange',
  standalone: true,
})
export class DateRangePipe implements PipeTransform {
  constructor(private datePipe: DatexPipe) {}

  transform(date1: Date | string | number, date2: Date | string | number): string {
    if (!date1 || !date2) return '';

    const d1 = new Date(date1);
    const d2 = new Date(date2);

    const sameDay =
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();

    const formatFirst = this.datePipe.transform(d1, 'ddd Do MMM HH:mm');
    const formatSecond = sameDay
      ? this.datePipe.transform(d2, 'HH:mm')
      : this.datePipe.transform(d2, 'ddd Do MMM HH:mm');

    return `${formatFirst} - ${formatSecond}`;
  }
}
